import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

const buttons = (confirmText, cancelText, onConfirm, onCancel) => ([
    <Button
        key="userConfirm"
        className="modal-btn"
        text={confirmText}
        onClick={onConfirm}
        ariaLabel="Confirm"
        isPrimary
    />,
    <Button
        key="userCancel"
        className="modal-btn"
        text={cancelText}
        onClick={onCancel}
        ariaLabel="Back"
        isSecondary />,
]);
const ConfirmPopup = ({ title, message, confirmText, cancelText, onConfirm, onCancel }) => (
    <div className="dim-layout">
        <div className="help-popup centered modal">
            <div className="title">{title}</div>
            <div className="content">
                <div className="problem">{message}</div>
                <div className="popup-buttons">
                    {buttons(confirmText, cancelText, onConfirm, onCancel)}
                </div>
            </div>
        </div>
    </div>
);

ConfirmPopup.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
};

ConfirmPopup.defaultProps = {
    title: '',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    onConfirm: () => {},
    onCancel: () => {}
};

export default ConfirmPopup;
